export enum Environment {
  Local,
  Dev,
  Prod
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/configuration/environment.ts